import React from 'react';
import Image from "../../Media/About.webp"
import "./About.css";

const About = () =>{
    return (
        <div className = "about">
            <img className = "noSelect" src = {Image} alt="" />
            <div className = "aboutTextContainer">
                <h2>Sovos Hakkında</h2>
                <p> SOVOS, müşteri ve sektör odaklı iş çözümleri sunan bir SAP hizmetleri sağlayıcısıdır. Dijital dünyanın yeni evrimi olan 'e-Dönüşüm' konseptinin yaratıcısı SOVOS, büyümekte olan Ar-Ge ekipleri ile dünya trendlerini takip ederek, Türkiye'de elektronik dönüşümün öncülüğünü omuzlayan ilk 3 firma arasında yer almaktadır.<br/>
                    <br/>
                    Şirket, yarısı Fortune 500 listesinde yer alan ve farklı büyüklükteki müşterilerine 70’ten fazla ülkede destek olmaktadır. Sovos’un SaaS ürünleri ve Sovos S1 Platformu çok sayıda profesyonel iş uygulaması ve devletlerin yasal uyum süreçleriyle entegredir. Hg ve TA Associates bünyesinde faaliyet gösteren Sovos’un Amerika ve Avrupa’da 14’ten fazla ofisi bulunmaktadır.<br/>
                    <br/>
                    Ayrıntılı bilgi için <a href = "https://www.sovos.com/tr" target = "_blank" rel = "noopener noreferrer">www.sovos.com/tr</a> web sitemizi ziyaret edebilir veya bizi <a href = "https://www.instagram.com/sovosturkiye/?igshid=YmMyMTA2M2Y%3D" target = "_blank" rel = "noopener noreferrer">Instagram</a>, <a href = "https://www.linkedin.com/company/sovosturkey/" target = "_blank" rel = "noopener noreferrer">LinkedIn</a> ve <a href = "https://twitter.com/SovosTurkey" target = "_blank" rel = "noopener noreferrer">Twitter</a> hesaplarımızdan takip edebilirsin.
                </p>
            </div>
        </div>
    )
}

export default About;